import React from 'react';
import { PostAttachmentProps } from '../../NewsfeedModels';
import IProvider from 'models/Providers/IProvider';
import MiniInternalProviderCard from 'parent-portal/providers/cards/internal/MiniInternalProviderCard';
import { track } from 'shared';

export default function Provider({ content }: PostAttachmentProps<IProvider>) {
    return (
        <div style={{ display: 'inline-flex', overflowX: 'scroll' }}>
            <MiniInternalProviderCard
                provider={content}
                onGoToProfile={() => {
                    track('Newsfeed: Shared Provider go to Profile click');
                }}
            />
        </div>
    );
}
